import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const AccommodationIndividualSelectRoomOptionsContainer = styled(Group)`
  padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
  min-width: 0;

  ${mediaQueryUp.tablet} {
    &.hasOptions {
      padding: 0;
    }

    &:not(.hasOptions) {
      padding-top: ${rem(20)};
    }
  }
`

interface Props {
  hasOptions: boolean
}

function AccommodationIndividualSelectRoomOptions({ hasOptions, children }: PropsWithChildren<Props>) {
  return <AccommodationIndividualSelectRoomOptionsContainer direction="vertical" gap={12} tabletGap={0} className={clsx({ hasOptions })}>
    {children}
  </AccommodationIndividualSelectRoomOptionsContainer>
}

export default AccommodationIndividualSelectRoomOptions
